// CRM Leads 线索管理 —— English i18n
// 命名空间: app.crm.lead.*

export const enGB_crm_lead = {
	// Menu
	'app.menu.crm': 'Lead Management',
	'app.menu.crm.lead.template': 'Lead Templates',
	'app.menu.crm.lead.source': 'Intake Channels',
	'app.menu.crm.lead.rule': 'Distribution Rules',
	'app.menu.crm.lead.pool': 'Manual Assignment',

	// ===== Template =====
	'app.crm.lead.template.title': 'Lead Templates',
	'app.crm.lead.template.detailTitle': 'Edit Lead Template',
	'app.crm.lead.template.singleton.button.reset': 'Reset',
	'app.crm.lead.template.singleton.empty': 'Failed to load template, please retry',
	'app.crm.lead.template.error.load': 'Failed to load template',
	'app.crm.lead.template.table.id': 'ID',
	'app.crm.lead.template.table.name': 'Name',
	'app.crm.lead.template.table.sourceCode': 'Channel',
	'app.crm.lead.template.table.isDefault': 'Default',
	'app.crm.lead.template.table.fieldCount': 'Fields',
	'app.crm.lead.template.table.createTime': 'Created',
	'app.crm.lead.template.label.name': 'Template Name',
	'app.crm.lead.template.label.sourceCode': 'Channel',
	'app.crm.lead.template.label.isDefault': 'Default Template',
	'app.crm.lead.template.placeholder.name': 'Enter template name',
	'app.crm.lead.template.placeholder.sourceCode': 'Empty means universal',
	'app.crm.lead.template.error.fields.empty': 'At least one field is required',
	'app.crm.lead.template.error.fields.key.duplicate': 'Duplicate field keys: {keys}',
	'app.crm.lead.template.field.key.readonlyHint': 'Field key maps to a database column and cannot be modified',
	'app.crm.lead.template.field.type.readonlyHint': 'Field type cannot be modified once confirmed',
	'app.crm.lead.template.button.copy': 'Copy',
	'app.crm.lead.template.button.addField': 'Add Field',
	'app.crm.lead.template.button.removeField': 'Remove',
	'app.crm.lead.template.field.key': 'Key',
	'app.crm.lead.template.field.label': 'Label',
	'app.crm.lead.template.field.type': 'Type',
	'app.crm.lead.template.field.module': 'Module',
	'app.crm.lead.template.field.module.index': 'Lead Master Table',
	// moduleCardTitle —— 详情页 / 模板页的"子表"卡片标题(与 module.* 的"域"叫法区分)
	'app.crm.lead.template.field.moduleCardTitle.index': 'Lead Master Table',
	'app.crm.lead.template.field.moduleCardTitle.assignment_distribution': 'Assignment & Distribution Sub-table',
	'app.crm.lead.template.field.module.intake': 'Intake Domain',
	'app.crm.lead.template.field.module.assignment_distribution': 'Assignment & Distribution Sub-table',
	'app.crm.lead.template.field.module.platform': 'Platform Domain',
	'app.crm.lead.template.field.moduleCardTitle.platform': 'Platform Sub-table',
	'app.crm.lead.template.field.module.follow': 'Follow-up Domain',
	'app.crm.lead.template.field.moduleCardTitle.follow': 'Follow-up Sub-table',
	'app.crm.lead.template.field.module.collaborate': 'Collaboration Domain',
	'app.crm.lead.template.field.moduleCardTitle.collaborate': 'Collaboration Sub-table',
	'app.crm.lead.template.field.module.call': 'Call Domain',
	'app.crm.lead.template.field.moduleCardTitle.call': 'Call Sub-table',
	// Sub-domains (Lead Master Table: Lead/Status/Intake/Insurance/Order/WeCom/Audit; Assignment & Distribution: Distribution/Assignment)
	'app.crm.lead.template.field.subModule.index': 'Lead Domain',
	'app.crm.lead.template.field.subModule.audit': 'Audit Domain',
	'app.crm.lead.template.field.subModule.intake': 'Intake Domain',
	'app.crm.lead.template.field.subModule.insurance': 'Insurance Domain',
	'app.crm.lead.template.field.subModule.status': 'Status Domain',
	'app.crm.lead.template.field.subModule.order': 'Order Domain',
	'app.crm.lead.template.field.subModule.wecom': 'WeCom Domain',
	'app.crm.lead.template.field.subModule.distribution': 'Distribution Domain',
	'app.crm.lead.template.field.subModule.assignment': 'Assignment Domain',
	'app.crm.lead.template.field.module.customCreate': '+ New Module',

	// Options editor (maintain {value, label} for select / multiselect fields)
	'app.crm.lead.template.field.options': 'Options',
	'app.crm.lead.template.button.options': 'Configure',
	'app.crm.lead.template.modal.options.title': 'Configure Options',
	'app.crm.lead.template.modal.options.tip': 'Maintain value/label mappings. Empty rows are ignored.',
	'app.crm.lead.template.modal.options.column.value': 'Value',
	'app.crm.lead.template.modal.options.column.label': 'Label',
	'app.crm.lead.template.modal.options.addRow': 'Add Option',
	'app.crm.lead.template.modal.options.empty': 'No options yet. Click "Add Option" to start.',
	'app.crm.lead.template.modal.options.error.empty': 'Value is required',
	'app.crm.lead.template.modal.options.error.duplicate': 'Values must be unique',
	'app.crm.lead.template.modal.createModule.title': 'New Module',
	'app.crm.lead.template.modal.createModule.label': 'Module Name',
	'app.crm.lead.template.modal.createModule.placeholder': 'e.g. industry',
	'app.crm.lead.template.modal.createModule.confirm': 'Add',
	'app.crm.lead.template.modal.createModule.success': 'Module added',
	'app.crm.lead.template.error.module.name.empty': 'Module name is required',
	'app.crm.lead.template.error.module.name.duplicate': 'Module name already exists',
	'app.crm.lead.template.field.visible': 'Visible',
	'app.crm.lead.template.field.searchable': 'Searchable',
	'app.crm.lead.template.field.section.title': 'Field Definition',
	'app.crm.lead.template.field.searchPlaceholder': 'Search by key / label',
	'app.crm.lead.template.field.filter.all': 'All Modules',
	'app.crm.lead.template.field.totalCount': '{count} / {total} fields',
	'app.crm.lead.template.field.newLabel': 'New Field',
	'app.crm.lead.template.field.empty': 'No fields yet. Click "Add Field" to start',
	'app.crm.lead.template.button.deleteField': 'Delete',
	'app.crm.lead.template.button.restoreField': 'Restore',
	'app.crm.lead.template.fieldType.text': 'Text',
	'app.crm.lead.template.fieldType.phone': 'Phone',
	'app.crm.lead.template.fieldType.email': 'Email',
	'app.crm.lead.template.fieldType.number': 'Number',
	'app.crm.lead.template.fieldType.date': 'Date',
	'app.crm.lead.template.fieldType.select': 'Single Select',
	'app.crm.lead.template.fieldType.multiselect': 'Multi Select',
	'app.crm.lead.template.fieldType.textarea': 'Textarea',
	'app.crm.lead.template.confirm.delete.hasHistoryTitle': 'Template is referenced by leads',
	'app.crm.lead.template.confirm.delete.hasHistoryContent': 'Deleting will lose historical field values, confirm?',
	'app.crm.lead.template.confirm.delete.unsavedTitle': 'Delete unsaved field?',
	'app.crm.lead.template.confirm.delete.unsavedContent':
		'This field has not been saved yet. Deletion is irreversible. Confirm?',

	// ===== Source =====
	'app.crm.lead.source.title': 'Intake Config',
	'app.crm.lead.source.detailTitle': 'Edit Intake Config',
	'app.crm.lead.source.detail.tab.basic': 'Basic Info',
	'app.crm.lead.source.detail.tab.mapping': 'Field Mapping',
	'app.crm.lead.source.step.basic': 'Basic Info',
	'app.crm.lead.source.step.mapping': 'Field Mapping',
	'app.crm.lead.source.button.next': 'Next',
	'app.crm.lead.source.button.back': 'Back',
	'app.crm.lead.source.detail.mapping.title': 'Field Mapping Rules for This Channel',
	'app.crm.lead.source.detail.mapping.targetTemplate': 'Target template: {name}',
	'app.crm.lead.source.detail.mapping.empty': 'No mapping rules. Click "Add Rule" to start',
	'app.crm.lead.source.table.id': 'ID',
	'app.crm.lead.source.table.name': 'Name',
	'app.crm.lead.source.table.type': 'Type',
	'app.crm.lead.source.table.callbackUrl': 'Callback URL',
	'app.crm.lead.source.table.createTime': 'Created',
	'app.crm.lead.source.label.name': 'Config Name',
	'app.crm.lead.source.label.type': 'Channel Type',
	'app.crm.lead.source.label.callbackUrl': 'Callback URL',
	'app.crm.lead.source.label.secret': 'Secret',
	'app.crm.lead.source.label.description': 'Description',
	'app.crm.lead.source.placeholder.name': 'Enter config name',
	'app.crm.lead.source.placeholder.description': 'Optional',
	'app.crm.lead.source.error.name.required': 'Config name is required',
	'app.crm.lead.source.hint.callbackUrl.auto':
		'The callback URL is auto-generated by the server based on the channel ID. No manual configuration required.',
	'app.crm.lead.source.type.douyin': 'Douyin',
	'app.crm.lead.source.type.xiaohongshu': 'Xiaohongshu',
	'app.crm.lead.source.type.wechat_work': 'WeCom',
	'app.crm.lead.source.type.manual': 'Manual',
	'app.crm.lead.source.type.web': 'Web',
	'app.crm.lead.source.type.other': 'Other',
	'app.crm.lead.source.button.viewSecret': 'Show Secret',
	'app.crm.lead.source.button.hideSecret': 'Hide Secret',
	'app.crm.lead.source.button.copyUrl': 'Copy URL',

	// ===== Source - Canvas (detail page = canvas) =====
	'app.crm.lead.source.detail.title.create': 'New Intake Config',
	'app.crm.lead.source.detail.title.edit': 'Edit Intake Config',
	'app.crm.lead.integration.node.dataSource': 'External Callback',
	'app.crm.lead.integration.node.standardTable': 'Lead Standard Table',
	'app.crm.lead.integration.node.platformTable': 'Platform Sub-table',
	'app.crm.lead.integration.mappingCount': 'mappings',
	'app.crm.lead.integration.hint':
		'Drag a field to create a mapping. Click an edge to select, then click Delete or press Backspace to remove.',
	'app.crm.lead.integration.button.deleteEdge': 'Delete Edge',
	'app.crm.lead.integration.button.addExternalField': 'Add External Field',
	'app.crm.lead.integration.confirm.switchType.title': 'Switch channel type?',
	'app.crm.lead.integration.confirm.switchType.content':
		'Switching the channel type will reset the data source fields and clear existing edges. Continue?',
	'app.crm.lead.integration.field.modal.title': 'Add External Field',
	'app.crm.lead.integration.field.label': 'Field Path',
	'app.crm.lead.integration.field.displayName': 'Display Name',
	'app.crm.lead.integration.field.type': 'Type',
	'app.crm.lead.integration.field.sample': 'Sample Value',
	'app.crm.lead.integration.field.error.empty': 'Field path and display name are required',
	'app.crm.lead.integration.field.error.duplicate': 'Field path already exists',

	// Import from JSON
	'app.crm.lead.integration.button.importFromJson': 'Import from JSON',
	'app.crm.lead.integration.json.modal.title': 'Generate External Fields from JSON',
	'app.crm.lead.integration.json.hint':
		'Paste a JSON sample of the external callback (nested objects supported). The system will flatten keys to dot-paths and infer types.',
	'app.crm.lead.integration.json.button.parse': 'Parse Preview',
	'app.crm.lead.integration.json.preview.title': 'Identified {count} field(s)',
	'app.crm.lead.integration.json.mode.replace': 'Replace existing',
	'app.crm.lead.integration.json.mode.append': 'Append',
	'app.crm.lead.integration.json.error.empty': 'Please paste JSON text',
	'app.crm.lead.integration.json.error.parse': 'JSON parse failed, check the format',
	'app.crm.lead.integration.json.error.emptyFields': 'No fields identified (empty object?)',
	'app.crm.lead.integration.json.error.parseFirst': 'Click "Parse Preview" first',
	'app.crm.lead.integration.json.success.imported': 'Imported {count} field(s)',

	// Edge style
	'app.crm.lead.integration.edge.type': 'Edge Style',
	'app.crm.lead.integration.edge.type.default': 'Bezier',
	'app.crm.lead.integration.edge.type.straight': 'Straight',
	'app.crm.lead.integration.edge.type.step': 'Step',
	'app.crm.lead.integration.edge.type.smoothstep': 'Smoothstep',
	'app.crm.lead.integration.edge.animated': 'Animated',

	// ===== Mapping =====
	'app.crm.lead.mapping.title': 'Field Mappings',
	'app.crm.lead.mapping.detailTitle': 'Edit Field Mapping',
	'app.crm.lead.mapping.table.id': 'ID',
	'app.crm.lead.mapping.table.sourceName': 'Channel',
	'app.crm.lead.mapping.table.templateName': 'Template',
	'app.crm.lead.mapping.table.ruleCount': 'Rules',
	'app.crm.lead.mapping.table.createTime': 'Created',
	'app.crm.lead.mapping.label.sourceId': 'Channel',
	'app.crm.lead.mapping.label.templateId': 'Template',
	'app.crm.lead.mapping.label.externalField': 'External Field Path',
	'app.crm.lead.mapping.label.externalSample': 'External Sample',
	'app.crm.lead.mapping.label.internalField': 'Internal Field',
	'app.crm.lead.mapping.label.transform': 'Transform',
	'app.crm.lead.mapping.label.expression': 'Expression',
	'app.crm.lead.mapping.label.defaultValue': 'Default Value',
	'app.crm.lead.mapping.label.remark': 'Remark',
	'app.crm.lead.mapping.placeholder.externalField': 'e.g. user.phone',
	'app.crm.lead.mapping.placeholder.expression': 'Regex or JSONPath',
	'app.crm.lead.mapping.placeholder.internalField': 'Select template field',
	'app.crm.lead.mapping.transform.direct': 'Direct',
	'app.crm.lead.mapping.transform.regex': 'Regex',
	'app.crm.lead.mapping.transform.jsonpath': 'JSONPath',
	'app.crm.lead.mapping.transform.default': 'Default',
	'app.crm.lead.mapping.transform.constant': 'Constant',
	'app.crm.lead.mapping.button.addRule': 'Add Rule',
	'app.crm.lead.mapping.button.testMapping': 'Test Mapping',
	'app.crm.lead.mapping.testTitle': 'Test Mapping',
	'app.crm.lead.mapping.testInputLabel': 'External Callback JSON',
	'app.crm.lead.mapping.testOutputLabel': 'Mapped Internal Data',
	'app.crm.lead.mapping.testInputPlaceholder': 'Paste a callback JSON...',
	'app.crm.lead.mapping.testEmpty': 'Enter JSON to preview mapping',
	'app.crm.lead.mapping.testRun': 'Run',
	'app.crm.lead.mapping.testClear': 'Clear',
	'app.crm.lead.mapping.error.externalField.required': 'External field path is required',
	'app.crm.lead.mapping.error.internalField.required': 'Internal field is required',

	// ===== Rule =====
	'app.crm.lead.rule.title': 'Distribution Rules',
	'app.crm.lead.rule.detailTitle': 'Edit Distribution Rule',
	'app.crm.lead.rule.table.id': 'ID',
	'app.crm.lead.rule.table.sourceName': 'Channel',
	'app.crm.lead.rule.table.name': 'Name',
	'app.crm.lead.rule.table.strategy': 'Strategy',
	'app.crm.lead.rule.table.createTime': 'Created',
	'app.crm.lead.rule.label.sourceId': 'Channel',
	'app.crm.lead.rule.label.name': 'Rule Name',
	'app.crm.lead.rule.label.strategy': 'Strategy',
	'app.crm.lead.rule.label.assigneeIds': 'Assignees',
	'app.crm.lead.rule.label.deptId': 'Department',
	'app.crm.lead.rule.label.weights': 'Weights',
	'app.crm.lead.rule.placeholder.name': 'Enter rule name',
	'app.crm.lead.rule.placeholder.assignee': 'Select sales reps',
	'app.crm.lead.rule.placeholder.weightAccount': 'Select sales rep',
	'app.crm.lead.rule.strategy.assign': 'Assign',
	'app.crm.lead.rule.strategy.round_robin': 'Round Robin',
	'app.crm.lead.rule.strategy.weight': 'Weighted',
	'app.crm.lead.rule.strategy.public_pool': 'Public Pool',
	'app.crm.lead.rule.strategyDesc.assign': 'Multi-select rotates by sales rep ID order, restarts from first on save',
	'app.crm.lead.rule.strategyDesc.round_robin': 'Distribute evenly across department members',
	'app.crm.lead.rule.strategyDesc.weight': 'Distribute by weight % — all weights should sum to 100',
	'app.crm.lead.rule.strategyDesc.public_pool': 'Go to the public lead pool, awaiting assignment',
	'app.crm.lead.rule.publicPoolHint': 'Public lead pool (fixed, 1)',
	'app.crm.lead.rule.button.addWeight': 'Add Weight',
	'app.crm.lead.rule.error.name.required': 'Rule name is required',
	'app.crm.lead.rule.error.assignee.required': 'Select at least one assignee',
	'app.crm.lead.rule.error.dept.required': 'Select a department',
	'app.crm.lead.rule.error.weights.required': 'Configure weights',
	'app.crm.lead.rule.weight.value': 'Weight',
	'app.crm.lead.rule.button.configRule': 'Configure Rule',
	'app.crm.lead.rule.button.viewLeads': 'View Leads',
	'app.crm.lead.rule.sheet.title': 'Leads Under This Rule',
	'app.crm.lead.rule.sheet.sourceHint': 'Channel: {name}',
	'app.crm.lead.rule.sheet.empty': 'No leads under this rule yet',

	// ===== Pool =====
	'app.crm.lead.pool.title': 'Lead Pool',

	// ===== List =====
	'app.crm.lead.list.title': 'Lead List',
	'app.crm.lead.list.search.poolOwner': 'Owner / Pool',
	'app.crm.lead.list.search.poolOwner.public': 'Public Pool',
	'app.crm.lead.list.search.poolOwner.unassigned': 'Unassigned Pool',
	'app.crm.lead.list.search.poolOwner.salesRep': 'Sales Reps',
	'app.crm.lead.list.table.name': 'Name',
	'app.crm.lead.list.table.phone': 'Phone',
	'app.crm.lead.list.table.source': 'Channel',
	'app.crm.lead.list.table.remark': 'Remark',
	'app.crm.lead.list.table.follower': 'Follower',
	'app.crm.lead.list.table.owner': 'Owner',
	'app.crm.lead.list.table.updateTime': 'Last Edit',
	'app.crm.lead.list.table.detail': 'Detail',
	'app.crm.lead.list.empty': 'No matching leads',
	'app.crm.lead.pool.poolOption.public': 'Public Pool',
	'app.crm.lead.pool.poolOption.unassigned': 'Unassigned Pool',
	'app.crm.lead.pool.label.poolTypes': 'Lead Pool',
	'app.crm.lead.pool.placeholder.poolTypes': 'Select (multiple allowed)',
	'app.crm.lead.pool.table.id': 'ID',
	'app.crm.lead.pool.table.name': 'Name',
	'app.crm.lead.pool.table.phone': 'Phone',
	'app.crm.lead.pool.table.sourceName': 'Source',
	'app.crm.lead.pool.table.status': 'Status',
	'app.crm.lead.pool.table.ownerName': 'Owner',
	'app.crm.lead.pool.table.followCount': 'Follows',
	'app.crm.lead.pool.table.lastFollowTime': 'Last Follow',
	'app.crm.lead.pool.table.createTime': 'Created',
	'app.crm.lead.pool.label.name': 'Name',
	'app.crm.lead.pool.label.phone': 'Phone',
	'app.crm.lead.pool.label.sourceCode': 'Source',
	'app.crm.lead.pool.label.status': 'Status',
	'app.crm.lead.pool.label.createTime': 'Created',
	'app.crm.lead.pool.placeholder.name': 'Search by name',
	'app.crm.lead.pool.placeholder.phone': 'Search by phone',
	'app.crm.lead.pool.button.create': 'New Lead',
	'app.crm.lead.pool.button.batchAssign': 'Batch Assign',
	'app.crm.lead.pool.button.release': 'Release to Pool',
	'app.crm.lead.pool.button.grab': 'Grab',
	'app.crm.lead.pool.button.assign': 'Assign',
	'app.crm.lead.pool.button.detail': 'Detail',
	'app.crm.lead.pool.button.call': 'Dial',
	'app.crm.lead.pool.button.order': 'Create Order',
	'app.crm.lead.pool.confirm.batchAssignTitle': 'Batch Assign',
	'app.crm.lead.pool.confirm.batchAssignContent': 'Choose a sales rep to assign',
	'app.crm.lead.pool.confirm.release.title': 'Release to public pool?',
	'app.crm.lead.pool.confirm.release.content': 'The lead will be moved to the public pool for claiming',
	'app.crm.lead.pool.success.release': 'Released to public pool',
	'app.crm.lead.pool.success.grab': 'Claimed',
	'app.crm.lead.pool.success.assign': 'Assigned to',
	'app.crm.lead.pool.warning.noSelection': 'Select at least one lead',
	'app.crm.lead.pool.warning.pickAssignee': 'Select an assignee',
	'app.crm.lead.pool.modal.assign.title': 'Assign Lead',
	'app.crm.lead.pool.modal.assign.target': 'Target Lead',
	'app.crm.lead.pool.modal.assign.assignee': 'Assign To',
	'app.crm.lead.pool.modal.batchAssign.title': 'Batch Assign Leads',
	'app.crm.lead.pool.modal.batchAssign.target': 'Selected leads',
	'app.crm.lead.pool.success.batchAssign': 'Batch assignment complete',
	'app.crm.lead.pool.success.batchAssignCount': 'OK {ok} / {total}',
	'app.crm.lead.pool.assign.targetPlaceholder': 'Select target sales rep',
	'app.crm.lead.pool.detailTitle.create': 'New Lead',
	'app.crm.lead.pool.detailTitle.edit': 'Edit Lead',
	'app.crm.lead.pool.detailTitle.view': 'Lead Detail',
	'app.crm.lead.pool.status.new': 'New',
	'app.crm.lead.pool.status.contacted': 'Contacted',
	'app.crm.lead.pool.status.qualified': 'Qualified',
	'app.crm.lead.pool.status.converted': 'Converted',
	'app.crm.lead.pool.status.lost': 'Lost',
	'app.crm.lead.pool.status.invalid': 'Invalid',

	// ===== Detail =====
	'app.crm.lead.detail.title': 'Lead Detail',
	'app.crm.lead.detail.tab.basic': 'Basic Info',
	'app.crm.lead.detail.tab.follow': 'Follow-ups',
	'app.crm.lead.detail.tab.assign': 'Assignment History',
	'app.crm.lead.detail.tab.call': 'Call Records',
	'app.crm.lead.detail.tab.order': 'Order Records',
	'app.crm.lead.detail.tab.followPlan': 'Follow Plans',
	'app.crm.lead.detail.tab.changeLog': 'Change Trail',
	'app.crm.lead.detail.section.basic': 'Basic Info',
	'app.crm.lead.detail.section.oceanengine': 'Ocean Engine',
	'app.crm.lead.detail.section.follow': 'Follow-ups',
	'app.crm.lead.detail.section.assign': 'Assignment History',
	'app.crm.lead.detail.section.custom': 'Custom Fields',
	// Business domains (Phase 1: view mode)
	'app.crm.lead.detail.section.customerInfo': 'Customer Info',
	'app.crm.lead.detail.section.customerInfo.basic': 'Basic Info',
	'app.crm.lead.detail.section.customerInfo.intake': 'Intake Info',
	'app.crm.lead.detail.section.assignmentDistribution': 'Assignment & Distribution',
	'app.crm.lead.detail.assignment.cardTitle': 'Assignment',
	'app.crm.lead.detail.distribution.cardTitle': 'Distribution',

	// Index domain fields
	'app.crm.lead.detail.index.field.leadId': 'Lead ID',
	'app.crm.lead.detail.index.field.leadSource': 'Source',
	'app.crm.lead.detail.index.field.oneId': 'one_id',
	'app.crm.lead.detail.index.field.liscustomerno': 'Customer No.',
	'app.crm.lead.detail.index.field.bkphone': 'Backup Phone',
	'app.crm.lead.detail.index.field.wechat': 'WeChat',
	'app.crm.lead.detail.index.field.qq': 'QQ',
	'app.crm.lead.detail.index.field.unionId': 'union_id',
	'app.crm.lead.detail.index.field.platformNickname': 'Platform Nickname',
	'app.crm.lead.detail.index.leadSource.api': 'API',
	'app.crm.lead.detail.index.leadSource.manual': 'Manual',
	'app.crm.lead.detail.index.leadSource.import': 'Bulk Import',

	// Intake domain fields
	'app.crm.lead.detail.intake.field.leaveTime': 'Intake Time',
	'app.crm.lead.detail.intake.field.leaveType': 'Intake Type',
	'app.crm.lead.detail.intake.field.leaveTags': 'Tags',
	'app.crm.lead.detail.intake.field.contactTime': 'Contact Time',
	'app.crm.lead.detail.intake.field.leaveRemark': 'Remark',
	'app.crm.lead.detail.intake.field.importBatchNo': 'Import Batch No.',
	'app.crm.lead.detail.intake.leaveType.phone': 'Phone',
	'app.crm.lead.detail.intake.leaveType.wechat': 'WeChat',
	'app.crm.lead.detail.intake.leaveType.qq': 'QQ',
	'app.crm.lead.detail.intake.leaveType.wechat_work': 'WeCom Friend',

	// Assignment domain fields
	'app.crm.lead.detail.assignment.field.bizChannel': 'Channel',
	'app.crm.lead.detail.assignment.field.branch': 'Branch',
	'app.crm.lead.detail.assignment.field.ownerName': 'Owner',
	'app.crm.lead.detail.assignment.field.preScreenAssistant': 'Pre-screen',
	'app.crm.lead.detail.assignment.field.leadOwner': 'Lead Owner',
	'app.crm.lead.detail.assignment.bizChannel.individual': 'Individual',
	'app.crm.lead.detail.assignment.bizChannel.broker': 'Brokerage',
	'app.crm.lead.detail.assignment.bizChannel.online': 'Online',
	'app.crm.lead.detail.assignment.bizChannel.bank': 'Bancassurance',

	// Distribution domain fields
	'app.crm.lead.detail.distribution.field.distributeMode': 'Mode',
	'app.crm.lead.detail.distribution.field.distributeBy': 'Assigned By',
	'app.crm.lead.detail.distribution.field.distributeTime': 'Assigned At',
	'app.crm.lead.detail.distribution.field.distributeCount': 'Assign Count',
	'app.crm.lead.detail.distribution.mode.direct': 'Direct',
	'app.crm.lead.detail.distribution.mode.preScreen': 'After Pre-screen',
	'app.crm.lead.detail.distribution.history.title': 'Assignment History',
	'app.crm.lead.detail.distribution.history.expandAll': 'Show More ({n})',
	'app.crm.lead.detail.distribution.history.collapse': 'Collapse',

	// Inline edit
	'app.crm.lead.detail.button.edit': 'Edit',
	'app.crm.lead.detail.editModal.title': 'Edit Field',
	'app.crm.lead.detail.editModal.success': 'Saved',
	'app.crm.lead.detail.editModal.cancel': 'Cancel',
	'app.crm.lead.detail.editModal.save': 'Save',
	'app.crm.lead.detail.editModal.confirmDiscardTitle': 'Discard unsaved changes?',
	'app.crm.lead.detail.editModal.confirmDiscardContent': 'You have unsaved edits',
	'app.crm.lead.detail.follow.empty': 'No follow-ups yet',
	'app.crm.lead.detail.assign.empty': 'No assignment records',
	'app.crm.lead.detail.call.empty': 'No call records yet',
	'app.crm.lead.detail.call.field.leadId': 'Lead ID',
	'app.crm.lead.detail.call.field.callId': 'Call ID',
	'app.crm.lead.detail.call.field.callTime': 'Call Time',
	'app.crm.lead.detail.call.field.callType': 'Call Type',
	'app.crm.lead.detail.call.field.caller': 'Caller',
	'app.crm.lead.detail.call.field.callee': 'Callee',
	'app.crm.lead.detail.call.field.receiverRole': 'Receiver Role',
	'app.crm.lead.detail.call.field.receiver': 'Receiver',
	'app.crm.lead.detail.call.field.answerStatus': 'Answer Status',
	'app.crm.lead.detail.call.field.ringDuration': 'Ring Duration',
	'app.crm.lead.detail.call.field.callDuration': 'Call Duration',
	'app.crm.lead.detail.call.field.hangupParty': 'Hangup Party',
	'app.crm.lead.detail.call.field.customerLocation': 'Customer Phone Location',
	'app.crm.lead.detail.call.field.missedReason': 'Missed Reason',
	'app.crm.lead.detail.call.field.remark': 'Remark',
	'app.crm.lead.detail.call.field.recording': 'Recording',
	'app.crm.lead.detail.call.callType.outbound': 'Outbound',
	'app.crm.lead.detail.call.callType.inbound': 'Inbound',
	'app.crm.lead.detail.call.answerStatus.answered': 'Answered',
	'app.crm.lead.detail.call.answerStatus.missed': 'Missed',
	'app.crm.lead.detail.call.answerStatus.voicemail': 'Voicemail',
	'app.crm.lead.detail.call.answerStatus.rejected': 'Rejected',
	'app.crm.lead.detail.call.hangupParty.caller': 'Caller',
	'app.crm.lead.detail.call.hangupParty.callee': 'Callee',
	'app.crm.lead.detail.call.hangupParty.system': 'System',
	'app.crm.lead.detail.call.receiverRole.sales': 'Sales',
	'app.crm.lead.detail.call.receiverRole.service': 'Support',
	'app.crm.lead.detail.call.receiverRole.ai': 'AI Agent',
	'app.crm.lead.detail.call.missedReason.busy': 'User Busy',
	'app.crm.lead.detail.call.missedReason.no_answer': 'No Answer',
	'app.crm.lead.detail.call.missedReason.rejected': 'Rejected',
	'app.crm.lead.detail.call.missedReason.power_off': 'Powered Off',
	'app.crm.lead.detail.call.missedReason.out_of_service': 'Out of Service',
	'app.crm.lead.detail.call.durationFormat': '{m}m {s}s',
	'app.crm.lead.detail.call.recording.play': 'Play Recording',
	'app.crm.lead.detail.order.empty': 'No order records yet',
	'app.crm.lead.detail.order.section.basic': 'Basic Info',
	'app.crm.lead.detail.order.section.saleArea': 'Sales Info',
	'app.crm.lead.detail.order.section.saleApply': 'Application Info',
	'app.crm.lead.detail.order.section.salePay': 'Payment Info',
	'app.crm.lead.detail.order.section.convert': 'Conversion & Collaboration',
	'app.crm.lead.detail.order.section.review': 'HQ Review',
	'app.crm.lead.detail.order.section.branchReview': 'Branch Review',
	'app.crm.lead.detail.order.section.reviewArea': 'Review Info',
	'app.crm.lead.detail.order.field.policyStatus': 'Policy Status',
	'app.crm.lead.detail.order.field.applyDate': 'Apply Date',
	'app.crm.lead.detail.order.field.effectiveDate': 'Effective Date',
	'app.crm.lead.detail.order.field.policyNo': 'Policy No.',
	'app.crm.lead.detail.order.field.applicant': 'Applicant',
	'app.crm.lead.detail.order.field.insured': 'Insured',
	'app.crm.lead.detail.order.field.productCode': 'Product',
	'app.crm.lead.detail.order.field.branchCompany': 'Branch',
	'app.crm.lead.detail.order.field.signBy': 'Sign By',
	'app.crm.lead.detail.order.field.payType': 'Pay Type',
	'app.crm.lead.detail.order.field.premium': 'Premium',
	'app.crm.lead.detail.order.field.payYears': 'Pay Years',
	'app.crm.lead.detail.order.field.converterName': 'Converter',
	'app.crm.lead.detail.order.field.collaborationNote': 'Collaboration',
	'app.crm.lead.detail.order.field.reviewerName': 'Reviewer',
	'app.crm.lead.detail.order.field.reviewStatus': 'Review Status',
	'app.crm.lead.detail.order.field.reviewTime': 'Review Time',
	'app.crm.lead.detail.order.field.reviewBasis': 'Review Basis',
	'app.crm.lead.detail.order.field.branchReviewerName': 'Branch Reviewer',
	'app.crm.lead.detail.order.field.branchReviewStatus': 'Branch Review Status',
	'app.crm.lead.detail.order.field.branchReviewTime': 'Branch Review Time',
	'app.crm.lead.detail.order.policyStatus.pending': 'Pending',
	'app.crm.lead.detail.order.policyStatus.active': 'Active',
	'app.crm.lead.detail.order.policyStatus.expired': 'Expired',
	'app.crm.lead.detail.order.policyStatus.lapsed': 'Lapsed',
	'app.crm.lead.detail.order.policyStatus.surrendered': 'Surrendered',
	'app.crm.lead.detail.order.policyStatus.rejected': 'Rejected',
	'app.crm.lead.detail.order.payType.single': 'Single Premium',
	'app.crm.lead.detail.order.payType.yearly': 'Yearly',
	'app.crm.lead.detail.order.payType.monthly': 'Monthly',
	'app.crm.lead.detail.order.payType.quarterly': 'Quarterly',
	'app.crm.lead.detail.order.reviewStatus.pending': 'Pending',
	'app.crm.lead.detail.order.reviewStatus.approved': 'Approved',
	'app.crm.lead.detail.order.reviewStatus.rejected': 'Rejected',
	'app.crm.lead.detail.order.reviewStatus.returned': 'Returned',
	'app.crm.lead.detail.followPlan.empty': 'No follow plans yet',
	'app.crm.lead.detail.followPlan.create': 'New Follow Plan',
	'app.crm.lead.detail.followPlan.field.leadId': 'Lead ID',
	'app.crm.lead.detail.followPlan.field.id': 'Plan ID',
	'app.crm.lead.detail.followPlan.field.follower': 'Follower',
	'app.crm.lead.detail.followPlan.field.planType': 'Plan Type',
	'app.crm.lead.detail.followPlan.field.planDate': 'Plan Date',
	'app.crm.lead.detail.followPlan.field.planTime': 'Plan Time',
	'app.crm.lead.detail.followPlan.field.remindBefore': 'Reminder',
	'app.crm.lead.detail.followPlan.field.createTime': 'Created',
	'app.crm.lead.detail.followPlan.field.content': 'Content',
	'app.crm.lead.detail.followPlan.planType.first_contact': 'First Contact',
	'app.crm.lead.detail.followPlan.planType.concept_comm': 'Concept Comm.',
	'app.crm.lead.detail.followPlan.planType.plan_making': 'Plan Making',
	'app.crm.lead.detail.followPlan.planType.plan_presentation': 'Plan Presentation',
	'app.crm.lead.detail.followPlan.planType.silence_activate': 'Reactivation',
	'app.crm.lead.detail.followPlan.remindBefore.5': '5 min before',
	'app.crm.lead.detail.followPlan.remindBefore.10': '10 min before',
	'app.crm.lead.detail.followPlan.form.error.planDate': 'Plan date must be today or later',
	'app.crm.lead.detail.followPlan.form.error.planDateRequired': 'Plan date is required',
	'app.crm.lead.detail.followPlan.form.error.planTypeRequired': 'Plan type is required',
	'app.crm.lead.detail.followPlan.form.error.contentRequired': 'Content is required',
	'app.crm.lead.detail.followPlan.creatorFixed': 'Creator (immutable)',
	'app.crm.lead.detail.changeLog.viewDetail': 'View Detail',
	'app.crm.lead.detail.changeLog.empty': 'No change records yet',
	'app.crm.lead.detail.changeLog.field.operateTime': 'Time',
	'app.crm.lead.detail.changeLog.field.operator': 'Changed By',
	'app.crm.lead.detail.changeLog.field.changeType': 'Type',
	'app.crm.lead.detail.changeLog.field.fieldName': 'Field',
	'app.crm.lead.detail.changeLog.field.module': 'Domain',
	'app.crm.lead.detail.changeLog.field.subModule': 'Sub-domain',
	'app.crm.lead.detail.changeLog.field.item': 'Item',
	'app.crm.lead.detail.changeLog.field.moreItems': 'and {n} more',
	'app.crm.lead.detail.changeLog.field.oldValue': 'Before',
	'app.crm.lead.detail.changeLog.field.newValue': 'After',
	'app.crm.lead.detail.changeLog.field.ip': 'IP',
	'app.crm.lead.detail.changeLog.field.remark': 'Remark',
	'app.crm.lead.detail.changeLog.filter.domain': 'All domains',
	'app.crm.lead.detail.changeLog.diff.arrow': '→',
	'app.crm.lead.detail.changeLog.changeType.create': 'Created',
	'app.crm.lead.detail.changeLog.changeType.edit': 'Edited',
	'app.crm.lead.detail.changeLog.changeType.status': 'Status',
	'app.crm.lead.detail.changeLog.changeType.assign': 'Assigned',
	'app.crm.lead.detail.changeLog.changeType.release': 'Released',
	'app.crm.lead.detail.changeLog.changeType.field_update': 'Field Update',
	'app.crm.lead.detail.changeLog.changeType.delete': 'Deleted',
	'app.crm.lead.detail.changeLog.changeType.restore': 'Restored',
	'app.h5.tab.leads': 'Leads',
	'app.h5.tab.plans': 'Plans',
	'app.h5.tab.me': 'Me',
	'app.crm.lead.detail.follow.action.call': 'Call',
	'app.crm.lead.detail.follow.action.message': 'SMS',
	'app.crm.lead.detail.follow.action.note': 'Note',
	'app.crm.lead.detail.follow.action.visit': 'Visit',
	'app.crm.lead.detail.assign.action.assign': 'Assign',
	'app.crm.lead.detail.assign.action.release': 'Release',
	'app.crm.lead.detail.assign.action.grab': 'Grab',
	'app.crm.lead.detail.call.title': 'One-Click Dial',
	'app.crm.lead.detail.call.dialing': 'Dialing...',
	'app.crm.lead.detail.call.connected': 'Connected',
	'app.crm.lead.detail.call.talking': 'In Call',
	'app.crm.lead.detail.call.ended': 'Call Ended',
	'app.crm.lead.detail.call.callee': 'Callee',
	'app.crm.lead.detail.call.caller': 'Your Number',
	'app.crm.lead.detail.call.duration': 'Duration',
	'app.crm.lead.detail.call.hangup': 'Hang Up',
	'app.crm.lead.detail.call.tip': 'Outbound integration pending — this is a placeholder demo',
	'app.crm.lead.detail.order.title': 'Create Order',
	'app.crm.lead.detail.order.leadInfo': 'Customer Info',
	'app.crm.lead.detail.order.product': 'Product',
	'app.crm.lead.detail.order.amount': 'Amount',
	'app.crm.lead.detail.order.policyNo': 'Policy No.',
	'app.crm.lead.detail.order.effectiveDate': 'Effective Date',
	'app.crm.lead.detail.order.remark': 'Remark',
	'app.crm.lead.detail.order.submit': 'Submit',
	'app.crm.lead.detail.order.success': 'Order submitted (placeholder)',
	'app.crm.lead.detail.order.tip': 'Create order — please use the detail view',
	'app.crm.lead.detail.createTitle': 'New Lead',
	'app.crm.lead.detail.editTitle': 'Edit Lead',
	'app.crm.lead.detail.phoneMasked': 'Middle 4 digits masked',
	'app.crm.lead.detail.error.save': 'Save failed',
	// Field schema viewer (read-only), mounted at CRM > Lead Templates
	'app.crm.lead.fields.title': 'Lead Templates',
	'app.crm.lead.fields.empty': 'No template yet. Please contact the admin.',
	'app.crm.lead.fields.field.key': 'Key',
	'app.crm.lead.fields.field.label': 'Label',
	'app.crm.lead.fields.field.module': 'Domain',
	'app.crm.lead.fields.field.type': 'Type',
	'app.crm.lead.fields.field.options': 'Options',
	'app.crm.lead.fields.field.searchable': 'Searchable',
	'app.crm.lead.fields.field.yes': 'Yes',
	'app.crm.lead.fields.field.no': 'No',
	'app.crm.lead.fields.error.load': 'Failed to load template'
}
